<status-now-loading-bar />
@if (!connectivity.online()) {
  <div
    class="border-b border-amber-300 bg-amber-50 px-4 py-2 text-center text-sm font-semibold text-amber-900"
    role="status"
    aria-live="polite"
  >
    StatusNow is offline. Live shipment data and actions are unavailable.
  </div>
}
<router-outlet />
